import { useMemo } from "react";
import { SET_DAY_MENU_RANGE_PATH } from "../../functions/src/admin/paths";
import { findSetDayMenuRangeForDate, type SetDayMenuRange } from "../../functions/src/common/setDayMenuRanges";
import { useDatabase } from "./firebaseHooks";

export type { SetDayMenuRange };

export function useSetDayMenuRangeForDate(date: string): SetDayMenuRange | null {
    const root = useDatabase(SET_DAY_MENU_RANGE_PATH);
    const rootVal = useMemo(
        () => root?.val() as Record<string, unknown> | null | undefined,
        [root]
    );
    return useMemo(() => findSetDayMenuRangeForDate(rootVal, date), [rootVal, date]);
}
